import React from "react";

const Terms = () => {
  return (
    <div className="terms-container">
      <h1>Terms & Conditions</h1>

      <p>
        Welcome to Transcare Agencies. By accessing or using our website,
        you agree to comply with and be bound by the following terms and
        conditions.
      </p>

      <h3>About Transcare Agencies</h3>
      <p>
        Transcare Agencies is a Kenyan-based company specializing in the
        design and production of efficient, clean-burning cookstoves that
        reduce cooking time, fuel costs, and environmental impact.
      </p>

      <h3>Use of Website</h3>
      <p>
        This website is intended to provide information about our services
        and products. Unauthorized use of this website may give rise to a
        claim for damages or legal action.
      </p>

      <h3>Intellectual Property</h3>
      <p>
        All content, logos, designs, and materials on this website belong
        to Transcare Agencies unless otherwise stated.
      </p>

      <h3>Changes to Terms</h3>
      <p>
        Transcare Agencies may update these Terms & Conditions at any time.
        Changes will be effective once posted on this page.
      </p>

      <h3>Contact</h3>
      <p>
        If you have any questions regarding these terms, please contact us
        through the contact information provided on our website.
      </p>
    </div>
  );
};

export default Terms;